Monitoring.Views ||= {}

class Monitoring.Views.TimeZoneSelectorView extends Backbone.View
  template: JST['backbone/templates/time_zone_selector']
  events:
    'change #timezone_offset_selector': '_onChangeTimezone'

  initialize: (timezone) ->
    @browser_zone = timezone || Date.browserTimeZoneString()

  render: ->
    @$el.html(@template())
    @_setDefaultZone()
    @

  getSelectedTimeZone: ->
    @$el.find('#timezone_offset_selector').val() || @browser_zone

  getSelectedTimeZoneText: ->
    selected_time_zone = @getSelectedTimeZone()
    selected_time_zone = selected_time_zone.replace('+', '\\+')
    this.$el.find("#timezone_offset_selector option[value="+selected_time_zone+"]").text() || "GMT -03:00"

  _setDefaultZone: ->
    if @_existsOption(@browser_zone)
      @$el.find('#timezone_offset_selector').val(@browser_zone)

  _existsOption: (option_value) ->
    @$el.find("option[value='#{option_value}']").length > 0

  _onChangeTimezone: =>
    @trigger('timezone:changed')
